// DETECTION VIEUX NAVIGATEUR
// HACK IE11
// https://github.com/miguelcobain/ember-paper/issues/1058
// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
  console.log('navigateur ancien !!');
  document.querySelector("html").classList.add('ie11');
}